import createEmailValidator from './create-email-validator';
import createPhoneValidator from './create-phone-validator';
import createRequiredValidator, { validateRequired } from './create-required-validator';

export default {
  createEmailValidator,
  createPhoneValidator,
  createRequiredValidator,
  validateRequired,
};
